import React from "react";
import { motion } from "framer-motion";
import { Clock, ShieldCheck, Zap, Moon, TrendingUp } from "lucide-react";

const ICONS = [Clock, ShieldCheck, Zap, Moon, TrendingUp];

export function WhyAutomate({ t }) {
  return (
    <section id="why-automate" className="relative section-pad border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-12 md:mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#00E5FF]" />
              <span className="eyebrow">{t.why_automate.eyebrow}</span>
            </div>
            <h2
              className="text-white font-semibold leading-[1.05] tracking-tight"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(28px, 4vw, 48px)",
              }}
            >
              {t.why_automate.heading}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.why_automate.items.map((it, i) => {
            const Icon = ICONS[i] || Zap;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.07, ease: "easeOut" }}
                data-testid={`why-automate-${i}`}
                className="bg-[#1C2331] border border-white/10 rounded-sm p-7 hover-lift"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-11 h-11 flex items-center justify-center border border-white/10 rounded-sm bg-[#0B132B]/60">
                    <Icon size={18} className="text-[#00E5FF]" />
                  </div>
                  <div
                    className="text-[#00E5FF] font-bold leading-none"
                    style={{ fontFamily: "'Outfit', sans-serif", fontSize: "28px" }}
                  >
                    0{i + 1}
                  </div>
                </div>
                <h3
                  className="text-white font-semibold leading-tight"
                  style={{ fontFamily: "'Outfit', sans-serif", fontSize: "20px" }}
                >
                  {it.title}
                </h3>
                <p
                  className="mt-3 text-[#9BA1A6] leading-relaxed"
                  style={{ fontFamily: "'Manrope', sans-serif", fontSize: "15px" }}
                >
                  {it.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
